<script setup lang="ts">
import XoLogo from '~/components/ui/XoLogo.vue'
import XoTabs, { Tab } from '~/components/ui/header/XoTabs.vue'
import PromotionDropdown from '~/components/ui/header/PromotionDropdown.vue'

const runtimeConfig = useRuntimeConfig()
const supplierOrderingUrl = runtimeConfig.public.SUPPLIER_ORDERING_URL

const props = withDefaults(
  defineProps<{
    tabs: Tab[]
    supplierName?: string
    undownloadCount?: number
  }>(),
  {
    supplierName: '',
    undownloadCount: 0,
  }
)

const isShowBadge = computed(() => {
  return props.undownloadCount > 0
})

const onClickDownloadIcon = () => {
  window.open(`${supplierOrderingUrl}/download_file`, '_blank')
}
</script>

<template>
  <nav ref="el" class="navigation-bar">
    <header class="xo-header">
      <div class="logo-wrapper">
        <XoLogo height="18px" />
      </div>
      <div class="download-icon" @click="onClickDownloadIcon">
        <span class="xo-icon icon-download" />
        <span v-if="isShowBadge" class="xo-badge" />
      </div>
      <div class="supplier-name">
        {{ supplierName }}
      </div>
    </header>
    <XoTabs class="tabs" :tabs="tabs">
      <template #dropdown="{ opened, openedKey }">
        <PromotionDropdown
          v-show="openedKey === 'promotion-report'"
          :opened="opened"
        />
      </template>
    </XoTabs>
  </nav>
</template>

<style scoped lang="scss">
.navigation-bar {
  position: fixed;
  top: 0;
  width: 100%;
  height: calc($header-height + $tabs-height + 1px);
  background-color: #fff;
  z-index: $z-index-header;

  .xo-header {
    height: $header-height;
    display: flex;
    align-items: center;
    box-shadow: 0 1px $order-color-border-gray;
    gap: 8px;

    .logo-wrapper {
      padding-left: 2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .download-icon {
      margin-left: auto;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background-color: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 50%;
      &:hover {
        background-color: #fff1e3;
        border-color: #eb7001;
        cursor: pointer;
        .xo-icon {
          &::before {
            color: #eb7001;
          }
        }
      }
      .xo-badge {
        position: absolute;
        top: 0;
        left: 0;
        width: 11px;
        height: 11px;
        background-color: $order-color-main;
        border-radius: 50%;
      }
    }

    .supplier-name {
      padding-right: 2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .tabs {
    margin-top: 1px;
  }
}
</style>
